import React from 'react';
import { L2oSummary } from '@havenengineering/module-shared-owners-library/dist/interfaces/l2oSummary';
import {
  Let2OwnBreaksSummary,
  MODE,
} from '@havenengineering/module-shared-owners-ui/dist/components/Let2OwnBreakSummary';

import { LettingConfigEntry } from '../../../types/lettingConfig';
import styles from './Let2OwnBreakSummaryWrapper.module.scss';
import { useRenewalSubmit } from './useRenewalSubmit';

export { RENEWAL_COMPLETION_ERROR } from './useRenewalSubmit';

interface Let2OwnBreakSummaryProps {
  isLoading: boolean;
  let2OwnSummary: L2oSummary;
  currentDate: string;
  mode: MODE;
  skipPayment?: boolean;
  breaksNotSavedAlertEnabled?: boolean;
  accountId?: number;
  setLoading?: (value: boolean) => void;
  setRenewalError?: (value: string | null) => void;
  let2OffsetIncome?: number;
  siteFeeYear?: number;
  lettingGrade?: string | null;
  lettingConfig: LettingConfigEntry[];
  hideSubmitButton?: boolean;
  hideTitle?: boolean;
  onContinue?: () => void;
}

export const Let2OwnBreaksSummaryWrapper: React.FC<
  Let2OwnBreakSummaryProps
> = ({
  isLoading,
  let2OwnSummary,
  currentDate,
  mode,
  skipPayment = false,
  breaksNotSavedAlertEnabled = false,
  accountId,
  setLoading,
  setRenewalError,
  let2OffsetIncome,
  siteFeeYear,
  lettingGrade,
  lettingConfig,
  hideSubmitButton = false,
  hideTitle = false,
  onContinue,
}) => {
  const handleRenewalClick = useRenewalSubmit({
    accountId,
    currentDate,
    skipPayment,
    lettingConfig,
    setLoading,
    setRenewalError,
  });

  return (
    <div className={styles.Let2OwnBreakSummaryWrapper}>
      <Let2OwnBreaksSummary
        isLoading={isLoading}
        let2OwnSummary={let2OwnSummary}
        mode={mode}
        handleRenewalClick={
          hideSubmitButton ? undefined : onContinue ?? handleRenewalClick
        }
        breaksNotSavedAlertEnabled={breaksNotSavedAlertEnabled}
        siteFeeYear={siteFeeYear}
        showMaxBreakList
        siteFeesAmount={let2OwnSummary.fullYearSiteFee || 0}
        lettingIncome={let2OffsetIncome || 0}
        lettingGrade={lettingGrade}
        hideTitle={hideTitle}
      />
    </div>
  );
};
